<lib-promotion-banner
  [width]="width"
  [margin]="margin"
  [text]="slice.text ?? productOfferPromotionTitle"
  [color]="slice.color"
  [position]="slice.position"
  [borderRadius]="borderRadius"
  [fontSize]="fontSize"
></lib-promotion-banner>
